import Vue from 'vue';
import { MutationTree } from 'vuex';
import { Course, CourseState } from './state';

const mutations: MutationTree<CourseState> = {
  SET_COURSE(state, course: Course) {
    state.course = course;
  },
  SET_AVAILABLE_COURSES(state, availableCourses: Course[]) {
    state.availableCourses = availableCourses;
  },
};

export default mutations;
